
import styled from 'styled-components'
import bgBaseballField from '../assets/images/bg_baseball_field.png'
import PlayerCardHolder from './PlayerCardHolder'
import PlayerCard from './PlayerCard'
import { useSquad } from '../contexts/SquadContext'
import BatterLineUpModal from './BatterLinupModal'
import PatchNoteModal from './PatchNoteModal'
import { useContext, useRef, useState } from 'react'
import getPlayerInfoFilledWithDummy from '../utils/getPlayerInfoFilledWithDummy'
import { exportSquadJson } from '../utils/exportSquadJson'

const Container = styled.div`
    width: 50rem;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
`

const BgBaseballFieldImg = styled.img`
    position: absolute;
    top: 10rem;
    align-self: center;
    height: 33.125rem;
    width: 37.9375rem;
`

const SubPlayerContainer = styled.div`
    position: absolute;
    bottom: 4rem;
    align-self: center;
    display: flex;
    flex-direction: row;
    gap: 0.475rem;
`

const TopButton = styled.div`
    padding: 0.4375rem 1.225rem;
    background-color: #545454;
    font-family: 'Pretendard Variable';
    font-size: 1rem;
    color: white;
    border-radius: 0.375rem;
    cursor: pointer;
`

const SettingContainer = styled.div`
    position: absolute;
    top: 1.5rem;
    left: 1rem;
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
`


export default function BatterSquadMaker() {

    const { playerInfos, removePlayer, setPlayers } = useSquad();

    const [ isModalOpen, setModalOpen ] = useState(false);
    const [ isPatchNoteModalOpen, setPatchNoteModalOpen ] = useState(false);

    const fileInputRef = useRef(null);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (e) => {
        try {
            const json = JSON.parse(e.target.result);
            onDataLoaded(json);
        } catch (err) {
            alert("데이터에 문제가 있습니다. 올바른 파일인지 확인해주세요.");
        }
        };
        reader.readAsText(file);
        
        // 같은 파일 재선택 가능하게 초기화
        event.target.value = '';
    }

    const onDummyFillClick = () => {
        const dummyPlayerInfo = getPlayerInfoFilledWithDummy(playerInfos);
        setPlayers(dummyPlayerInfo);
    }
    
    const onExportClick = () => {
        const isConfirmed = window.confirm("현재 스쿼드 데이터를 파일로 내보내시겠습니까?");
    
        if (isConfirmed) {
            const data = playerInfos;
            exportSquadJson(data);
        }
    }

    const onImportClick = () => {
        fileInputRef.current.click();
    }

    const onDataLoaded = (data) => {
        setPlayers(data);
    }

    const onPatchNoteClick = () => {
        setPatchNoteModalOpen(true);
    }

    return (
        <Container>
            <BgBaseballFieldImg src={bgBaseballField} alt="타자 스쿼드 메이커 배경" />

            <SettingContainer>
                <TopButton
                    onClick={() => {setModalOpen(true)}}
                >
                    타순 설정
                </TopButton>

                <TopButton onClick={onDummyFillClick}>
                    더미 데이터 채우기
                </TopButton>

                <TopButton onClick={onExportClick}>
                    스쿼드 내보내기
                </TopButton>

                <TopButton onClick={onImportClick}>
                    스쿼드 불러오기
                    <input
                        type="file"
                        accept=".json"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                        style={{ display: 'none' }} 
                    />
                </TopButton>

                <TopButton onClick={onPatchNoteClick}>
                    패치 노트
                </TopButton>

            </SettingContainer>

            <BatterLineUpModal
                isModalOpen={isModalOpen}
                closeModal={() => {setModalOpen(false)}}
            />

            <PatchNoteModal
                isOpen={isPatchNoteModalOpen}
                onClose={() => {setPatchNoteModalOpen(false)}}
            />

            <PlayerCardHolder 
                position="LF" 
                player={playerInfos['LF']}
            />

            <PlayerCardHolder 
                position="CF" 
                player={playerInfos['CF']}
            />

            <PlayerCardHolder 
                position="RF" 
                player={playerInfos['RF']}
            />

            <PlayerCardHolder 
                position="SS" 
                player={playerInfos['SS']}
            />

            <PlayerCardHolder 
                position="2B" 
                player={playerInfos['2B']}
            />

            <PlayerCardHolder 
                position="1B" 
                player={playerInfos['1B']}
            />

            <PlayerCardHolder 
                position="3B" 
                player={playerInfos['3B']}
            />

            <PlayerCardHolder 
                position="C" 
                player={playerInfos['C']}
            />

            <PlayerCardHolder 
                position="DH" 
                player={playerInfos['DH']}
            />

            <SubPlayerContainer>
                <PlayerCardHolder 
                    position="SUB1" 
                    player={playerInfos['SUB1']}
                />

                <PlayerCardHolder 
                    position="SUB2"  
                    player={playerInfos['SUB2']}
                />

                <PlayerCardHolder 
                    position="SUB3"  
                    player={playerInfos['SUB3']}
                />  

                <PlayerCardHolder
                    position="SUB4" 
                    player={playerInfos['SUB4']}
                />

                <PlayerCardHolder
                    position="SUB5"  
                    player={playerInfos['SUB5']}
                />

                <PlayerCardHolder   
                    position="SUB6"  
                    player={playerInfos['SUB6']}
                />
{/* 
                <PlayerCard
                    player={dummyPlayer}
                /> */}

            </SubPlayerContainer>
        </Container>
    )
}